import { ReactElement } from 'react';
import { UserPopulatedDTO } from '../api/generated';
import { HeapRecordings } from '../components/Recordings/HeapRecordings';

interface HeapRecordingsPageProps {
  user: UserPopulatedDTO;
}

export function HeapRecordingsPage({ user }: HeapRecordingsPageProps): ReactElement {
  return <HeapRecordings user={user} />;
}
